import { Injectable } from '@angular/core';
import { PreInitSettingsService, IPreInitAppSettings } from './settings/pre-init-setting.service';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AppSettingsService } from './app-settings.service';
import { PGHAppLoadService } from './pgh-app-load.service';
import { AppInsightsService } from './app-insights.service';

@Injectable({
  providedIn: 'root'
})
export class PreInitService {
  constructor(
    private preInitSettingsService: PreInitSettingsService,
    private appSettingsService: AppSettingsService,
    private appLoadService: PGHAppLoadService,
    private appInsightsService: AppInsightsService
  ) { }

  loadConfig(): Observable<any> {
    return this.appSettingsService
      .getPageJson<IPreInitAppSettings>('config/appSettings.json')
      .pipe(
        tap((config) => {
          console.log('initiailize app');
          this.appLoadService.initializeApplication();
          this.preInitSettingsService.setSettings(config);
          var settings = this.preInitSettingsService.getSettings();
          let insKey = settings?.applicationInsights?.instrumentationKey;
          if (insKey) {
            this.appInsightsService.loadAppInsightConfigs(insKey);
          }
        })
      );
  }
}
